import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Loader from '../components/Loader';

/**
 * VideoPage component - displays a single karaoke video
 */
const VideoPage = () => {
  const { id } = useParams();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`/api/videos/${id}`);
        setVideo(data);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load video');
        setLoading(false);
      }
    };

    fetchVideo();
  }, [id]);

  return (
    <Container className="py-4">
      <Link to="/" className="btn btn-light mb-4">
        Go Back
      </Link>
      
      {loading ? (
        <div className="d-flex justify-content-center p-5">
          <Loader />
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : !video ? (
        <div className="alert alert-info">
          Video not found
        </div>
      ) : (
        <Card className="shadow-sm">
          <Card.Body>
            <h1 className="mb-3">{video.title}</h1>
            <div className="ratio ratio-16x9 mb-3">
              {video.type === 'youtube' && video.embedId ? (
                <iframe
                  title={video.title}
                  className="w-100 h-100"
                  src={`https://www.youtube.com/embed/${video.embedId}?rel=0&modestbranding=1&autoplay=1`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              ) : (
                <video
                  controls
                  autoPlay
                  className="w-100"
                  src={video.path ? `${video.path}` : (video.originalUrl || '')}
                  poster={video.thumbnail ? `${video.thumbnail}` : "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='450' viewBox='0 0 800 450'%3E%3Crect width='800' height='450' fill='%23333'/%3E%3Ctext x='400' y='225' font-family='Arial' font-size='30' fill='white' text-anchor='middle' dominant-baseline='middle'%3ENo Thumbnail%3C/text%3E%3C/svg%3E"}
                  crossOrigin="anonymous"
                  onError={(e) => {
                    console.error('Video error:', e);
                    e.target.onerror = null;
                  }}
                />
              )}
            </div>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

// Export the component as default
export default VideoPage;
